import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useMemo, useState } from "react"
import { useNavigate } from "react-router-dom"
import { Container, CardBody, Card, Col, Row } from "reactstrap"

import Loader from "components/Common/Loader"
import { axiosbaseurl } from "configure"

import moment from "moment"
import avatar4 from "../../assets/images/users/profile.png"
import CommonTable from "components/Common/CommonTable"

const NotificationIndex = () => {
  const [table_data, settable_data] = useState([])

  const [loading, setLoading] = useState(false)

  const queryParams = new URLSearchParams(window.location.search);
  const notiType = queryParams.get('module');

  useEffect(() => {
    const getNotifications = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get("/bell-notification")
        if (response.data.success) {
          if (notiType) {
            settable_data(response.data.data
              ?.filter(noti => noti.module.toLowerCase().includes(notiType.toLowerCase())
              ).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)))
            return
          }
          settable_data(response.data.data.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)))

        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getNotifications()
  }, [])

  useEffect(() => {
    document.title = "Notifications | Peacock Accountants Limited"
  }, [])

  return (
    <>
      {loading && <Loader />}

      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Notifications"} />
          <div>
            <Row>
              <Col md={12}>
                <Card>
                  <CardBody>
                    <TableComponent
                      table_data={table_data}
                      notiType={notiType}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
  )
}

const TableComponent = ({ table_data, notiType }) => {
  const navigate = useNavigate()

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: " col-1 text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: "Notification",
        accessor: "title",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <div className="d-flex align-items-center ">
              <div className="text-center employee-margin-right">
                <img
                  src={
                    cellProps.row.original?.profileImage &&
                      cellProps.row.original?.profileImage !== "null"
                      ? `${process.env.REACT_APP_IMAGE_PATH}/${cellProps.row.original?.profileImage}`
                      : avatar4 // Fallback to default image
                  }
                  alt="img"
                  className="rounded-circle"
                  width={35}
                  height={35}
                />
              </div>
              <div>{cellProps.row.original?.title}</div>
            </div>
          )
        },
      },
      {
        Header: "Description",
        accessor: "description",
        disableFilters: true,
        filterable: true,
        className: "",
      },
      {
        Header: "Date",
        accessor: "Date",
        disableFilters: true,
        filterable: true,
        className: "col-2",
        Cell: cellProps => (
          <span>
            {moment(cellProps.row.original.createdAt).format(
              "DD MMM YYYY | hh:mm A"
            )}
          </span>
        ),
      },
    ],
    []
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>

      <CommonTable
        columns={columns}
        data={data}
        heading={`All Notifications ${notiType ? `(${notiType})` : ''}`}
      >
        <div>
          <button
            onClick={() => navigate(-1)}
            className="btn btn-secondary bg-dark ms-3"
          >
            <i className="fas fa-arrow-left me-3"></i>
            Back
          </button>
        </div>
      </CommonTable>
    </>
  )
}

export default NotificationIndex
